export function attachPreviewUrl(url: string, origin?: string): string {
  try {
    const parsed = new URL(url, "https://attachment.invalid");
    if (!url.startsWith("/") && parsed.origin !== origin) return url;
    if (!parsed.pathname.startsWith("/uploads/") || !/\.(jpg|jpeg|png|gif|webp|avif)$/i.test(parsed.pathname)) return url;
    parsed.searchParams.set("thumb", "160");
    return url.startsWith("/") ? `${parsed.pathname}${parsed.search}${parsed.hash}` : parsed.href;
  } catch { return url; }
}
